import { defineStore } from 'pinia'
import axios from 'axios'
import { useLocalStorage } from '@vueuse/core'

const TTL = 1000 * 60 * 10 // 10 minutes
const newExpiryTime = () => new Date().getTime() + TTL
const hasCacheExpired = (cacheExpiry) => !cacheExpiry || new Date().getTime() > cacheExpiry
export const useIndustryStore = defineStore('industryStore', {
  state: _ => ({
    isFetchingIndustries: false,
    hasIndustriesFetched: false,
    industries: useLocalStorage('industryStore_industries', []),
    industriesExpiry: useLocalStorage('industryStore_industriesExpiry', null),
    isFetchingIndustryBusinesses: false,
    industryBusinesses: { endAt: 0, startFrom: 0, businesses: [] }
  }),
  getters: {
    industriesWithoutAll () {
      if (this.industries.length) {
        const removeIndustryAll = this.industries.map(industry => industry.name).indexOf('All')
        if (removeIndustryAll > -1) {
          const clone = this.industries.slice()
          clone.splice(removeIndustryAll, 1)
          return clone
        }
      }
      return this.industries
    }
  },
  actions: {
    getIndustry (indSlug) {
      return this.industries.find(industry => industry.slug === indSlug) || {}
    },
    async fetchIndustries () {
      this.isFetchingIndustries = true
      try {
        if (hasCacheExpired(this.industriesExpiry)) {
          const resp = await axios.get('/industries')
          const { data } = resp
          this.industries = data
          this.industriesExpiry = newExpiryTime()
        }
        this.hasIndustriesFetched = true
      } catch (error) {
        return error
      } finally {
        this.isFetchingIndustries = false
      }
    },
    fetchIndustryBusinesses (filters) {
      return this._fetchIndustryBusinesses(`/industries/${filters.indSlug}/businesses`, filters)
    },
    fetchSubIndustryBusinesses (subIndSlug, filters) {
      return this._fetchIndustryBusinesses(`/industries/${filters.indSlug}/sub-ind/${subIndSlug}/businesses`, filters)
    },
    async _fetchIndustryBusinesses (api, filters) {
      this.isFetchingIndustryBusinesses = true
      try {
        const resp = await axios.get(api, {
          params: {
            filters: {
              business_status: filters.bizStatus
            },
            sort: {
              sort_by: filters.sortBy
            },
            paging: {
              start: filters.startFrom,
              count: 10
            }
          }
        })
        const { data } = resp
        this.industryBusinesses = {
          endAt: data.data.endAt,
          startFrom: data.data.startFrom,
          businesses: data.data.businesses
        }
      } catch (error) {
        this.industryBusinesses.businesses = []
        return Promise.reject(error)
      } finally {
        this.isFetchingIndustryBusinesses = false
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/IndustryStore.js